// DatePickerFromTo.jsx
'use client';

import React, { useMemo, useCallback } from 'react';
import SmartDateField from '../../DatePickers/SmartDateField';

// helpers
const pad = (n) => String(n).padStart(2, '0');
const toISODate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const toISOHM = (d) => `${pad(d.getHours())}:${pad(d.getMinutes())}`;

// build min = now + 4h, rounded up to next 15 minutes
const buildMinDateTime = () => {
  const d = new Date();
  d.setMinutes(d.getMinutes() + 4 * 60);
  const m = d.getMinutes();
  const delta = (15 - (m % 15)) % 15; // round up to next 15m
  d.setMinutes(m + delta, 0, 0);
  return `${toISODate(d)}T${toISOHM(d)}`;
};

export default function DatePickerFromTo({
  setSingleDate,
  singleDate,
  setTimeValue,
  timeValue,
  error,
  helperText,
}) {
  const minDT = useMemo(buildMinDateTime, []);
  const fallbackNow = useMemo(() => minDT, [minDT]);

  // Compose the SmartDateField value: "YYYY-MM-DDTHH:mm"
  const fieldValue = useMemo(() => {
    if (singleDate && timeValue) {
      const [hh = '00', mm = '00'] = String(timeValue).split(':');
      return `${singleDate}T${pad(hh)}:${pad(mm)}`;
    }
    return fallbackNow;
  }, [singleDate, timeValue, fallbackNow]);

  // When user picks a value, update your two separate states
  const handleChange = useCallback((isoLocal /* "YYYY-MM-DDTHH:mm" */) => {
    if (!isoLocal) return;
    const [d, hm] = String(isoLocal).split('T');
    const [hh = '00', mm = '00'] = (hm || '').split(':');
    setSingleDate(d || '');
    setTimeValue(`${pad(hh)}:${pad(mm)}:00`); // keep seconds in your store
  }, [setSingleDate, setTimeValue]);

  return (
    <div className="input-style-check" style={{ padding: 0, width: '100%' }}>
      <div className="d-flex justify-between px-10">
        <p className="text-12 fw-500 ls-2 lh-16">Pick-up Date</p>
      </div>

      <SmartDateField
        type="datetime"
        value={fieldValue}
        setValue={handleChange}
        minDateTime={minDT}     // ⬅️ blocks any time earlier than now+4h
        stepMinutes={15}        // ⬅️ minute step (rounds on change)
        showHint={false}
        fullWidth
        sx={{
          border: error ? '1px solid red' : '1px solid transparent',
          borderRadius: 8,
          px: 1,
          fontSize: 14,
        }}
      />

      {error && (
        <div style={{ color: 'red', fontSize: 11 }}>{helperText}</div>
      )}
    </div>
  );
}
